<template>
  <inertia-link :href="route('contract.show', {'contract': contract.id})">
    {{ contract.number }}
  </inertia-link>
</template>

<script>
export default {
   props: {
      contract: {
         type: Object,
         required: true,
      }
   }
}
</script>

<style>
</style>
